export const activeSubstances = {
    state: {
        status: 'idle',
        activeSubstances: [],
        areAllFetched: false,
        pagination: {
            limit: 20,
            page: 1
        },
        query: {}
    },
    mutations: {
        SET_ACTIVESUBSTANCES_STATUS(state, status) {
            state.status = status
        },
        SET_ACTIVESUBSTANCES(state, activeSubstances) {
            state.activeSubstances = activeSubstances
        },
        SET_ACTIVESUBSTANCES_QUERY(state, payload) {
            this.$vue.set(state.query, payload.name, payload.value)
        },
        SET_ACTIVESUBSTANCES_PAGINATION_PAGE(state, page) {
            state.pagination.page = page
        },
        SET_ACTIVESUBSTANCES_ALL_FETCHED(state, areAllFetched) {
            state.areAllFetched = areAllFetched
        }
    },
    actions: {
        fetchActiveSubstances({ state, commit, dispatch, getters }) {
            commit('SET_ACTIVESUBSTANCES', [])
            commit('SET_ACTIVESUBSTANCES_STATUS', 'loading')
            return dispatch('resetActiveSubstancesPagination').then(() => {
                return this.$api.get(`api/active-substances.json?${getters.activeSubstancesQueryString}`).then((response) => {
                    commit('SET_ACTIVESUBSTANCES', response.data.data)
                    commit('SET_ACTIVESUBSTANCES_ALL_FETCHED', response.data.total_count ? response.data.total_count <= state.activeSubstances.length : response.data.data.length === 0)
                    commit('SET_ACTIVESUBSTANCES_STATUS', 'idle')
                }).catch(error => {
                    commit('SET_ACTIVESUBSTANCES_STATUS', 'error')
                    return Promise.reject(error)
                })
            })
        },
        fetchActiveSubstancesNextPage({ state, commit, getters }) {
            if(state.areAllFetched) {
                return false
            }
            commit('SET_ACTIVESUBSTANCES_STATUS', 'loadingMore')
            commit('SET_ACTIVESUBSTANCES_PAGINATION_PAGE', state.pagination.page + 1)
            return this.$api.get(`api/active-substances.json?${getters.activeSubstancesQueryString}`).then((response) => {
                commit('SET_ACTIVESUBSTANCES', state.activeSubstances.concat(...response.data.data))
                commit('SET_ACTIVESUBSTANCES_ALL_FETCHED', response.data.total_count ? response.data.total_count <= state.activeSubstances.length : response.data.data.length === 0)
                commit('SET_ACTIVESUBSTANCES_STATUS', 'idle')
            }).catch(error => {
                commit('SET_ACTIVESUBSTANCES_STATUS', 'error')
                return Promise.reject(error)
            })
        },
        setActiveSubstancesSearchQuery({ state, commit }, payload) {
            // check if payload has valid properties
            if(Object.prototype.hasOwnProperty.call(payload, 'name') &&
               Object.prototype.hasOwnProperty.call(payload, 'value')) {
                commit('SET_ACTIVESUBSTANCES_QUERY', payload)
            } else {
                console.error('Invalid payload')
            }
        },
        resetActiveSubstancesQuery({ commit, dispatch }) {
            commit('SET_ACTIVESUBSTANCES_ALL_FETCHED', false)
            return dispatch('resetFromInitialState', {
                module: 'activeSubstances',
                object: 'query'
            })
        },
        resetActiveSubstancesPagination({ commit, dispatch }) {
            commit('SET_ACTIVESUBSTANCES_ALL_FETCHED', false)
            return dispatch('resetFromInitialState', {
                module: 'activeSubstances',
                object: 'pagination'
            })
        }
    },
    getters: {
        activeSubstancesStatus: (state) => {
            return state.status
        },
        activeSubstances: (state) => {
            if(state.activeSubstances) {
                return state.activeSubstances
            }
        },
        activeSubstancesQuery: (state) => {
            return state.query
        },
        activeSubstancesQueryString: (state) => {
            const pagination = `page=${state.pagination.page}&limit=${state.pagination.limit}`
            const params = Object.entries(state.query)
                .filter(([key, value]) => value !== '')
                .map(([key, val]) => `${key}=${encodeURIComponent(val)}`)
                .join('&')
            return `${pagination}&${params}`
        }
    }
}
